const _ = "_avatarGroupContainer_22ize_1", o = "_showAddMore_22ize_4", e = "_wrapped_22ize_13", s = "_xxl_22ize_16", t = "_xl_22ize_19", a = "_l_22ize_22", r = "_m_22ize_25", n = "_sm_22ize_28", i = {
  avatarGroupContainer: _,
  showAddMore: o,
  wrapped: e,
  xxl: s,
  xl: t,
  l: a,
  m: r,
  sm: n
};
export {
  _ as avatarGroupContainer,
  i as default,
  a as l,
  r as m,
  o as showAddMore,
  n as sm,
  e as wrapped,
  t as xl,
  s as xxl
};
//# sourceMappingURL=AvatarGroup.module.scss.js.map
